import React, { useEffect } from "react";
import dayjs from "dayjs";

import { percentage, proper } from "lib/common";
import { sentimentCalc } from "lib/atsent";

import {
  useRecoilState,
  useRecoilStateLoadable,
  useRecoilValue,
  useRecoilValueLoadable,
  useSetRecoilState,
} from "recoil";
import {
  asyncGetThreadList,
  currentThreadSelected,
  threadListState,
} from "lib/store/dashboard";
import { asyncGetProject } from "lib/store/project";
import { threadPageState, threadTotalPageState } from "lib/store/thread";

import { Box, FaceIcon, RemovableList } from "@atsent/components";

import { HeaderNSidebar } from "components/template/HeaderNSidebar";
import { DashboardDateToolbar } from "components/atom/DashboardDateToolbar";
import { ThreadList } from "components/atom/TreadList";
import { ResultTable } from "components/atom/ResultTable";

import "./ThreadPage.scss";

export type ThreadPageProps = {
  cx?: string;
};

export const ThreadPage: React.FC<ThreadPageProps> = ({ cx = "" }) => {
  const [page, setPage] = useRecoilState(threadPageState);
  const setTotalPage = useSetRecoilState(threadTotalPageState);
  const currentSelected = useRecoilState(currentThreadSelected);
  const [{ id, idx, plain_text, created_at, result }, setCurrentSelected] =
    currentSelected;

  const list = useRecoilValue(threadListState);
  const project = useRecoilValueLoadable(asyncGetProject);
  const [threadValue, setThreadValue] = useRecoilStateLoadable(
    asyncGetThreadList(page)
  );

  useEffect(() => {
    if (
      threadValue.state === "hasValue" &&
      id === 0 &&
      threadValue.contents.results.length > 0
    ) {
      setCurrentSelected(() => ({ ...threadValue.contents.results[0] }));
      setThreadValue(threadValue.contents);
    }
    // eslint-disable-next-line
  }, [threadValue.state, threadValue.contents, page]);

  return (
    <HeaderNSidebar cx={`ThreadPage ${cx}`}>
      <DashboardDateToolbar cx={"SelectDate align-center"} />
      <Box cx={"main"}>
        <ThreadList
          currentState={currentSelected}
          setPage={setPage}
          setTotalPage={setTotalPage}
          asyncLoadableState={[threadValue, setThreadValue]}
          list={list}
        />
        <div className={"table"}>
          <div className="top">
            <div className="l">
              <span>{idx}</span>
              <span className={"title"}>{plain_text}</span>
            </div>
            <span>{dayjs(created_at).format("MMM DD. YYYY")}</span>
          </div>
          <div className="label-wrapper">
            <span>주요 카테고리</span>
            <div className="Label">
              {!!result ? result.aspect : "분석 대기중"}
            </div>
          </div>
          <div className="label-wrapper">
            <span>감성</span>
            <div className="span-wrapper">
              <span>
                {result?.sentiment} {percentage(result?.sentiment_score, 0)}%
              </span>
              <FaceIcon cx={sentimentCalc(result?.sentiment)} />
            </div>
          </div>
        </div>
        <div className={"phrase"}>
          <div className={"phrase-title"}>
            <span className={"title"}>분석 구문</span>
            <div className={"label"}>{proper(project.contents.category)}</div>
          </div>
          <RemovableList list={[{ text: plain_text }]} click={() => null} />
        </div>
        <ResultTable result={result} />
      </Box>
    </HeaderNSidebar>
  );
};
